import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import profileLogo from '../../media/user.png';
import LogContext from '../../context/LogContext';
import axios from 'axios';
import { accountScroll } from '../../utils/accountScroll';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;
export default function Wishlist() {
  const navigate = useNavigate();
  const myContext = useContext(LogContext);
  const [wishlist, setWishlist] = useState([]);

  const getWishlist = async (email) => {
    try {
      const response = await fetch(`${backendUrl}/getWishlistData`, {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ email: email })
    });
      if (response.ok) {
        const data = await response.json();
        setWishlist(data["data"]);
      }
    } catch (error) {
      console.log("cant get the wishlist");
    }
  };

  const deleteHandler = async (index) => {
    try {
      const response = await fetch(`${backendUrl}/deleteFromWishlist`, {
      method: 'POST',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ index, email: myContext.user.email })
    });
      if (response.ok) {
        console.log("deleted successfully from wishlist");
      }
    } catch (error) {
      console.log("error deleting from wishlist");
    }
  };
  const handelLogout = async () => {
    try {
      const response = await axios.get(`${backendUrl}/logout`, {
      credentials: true // Include cookies in the request
    });
    navigate('/', { replace: true });
    setTimeout(() => {
      window.location.reload();
    }, 0);
    console.log("Logout successfully");
    } catch (error) {
      console.log("Some error occured", error)
    }
  }
  const handleScroll = () => {
    if (window.innerWidth <= 576) {
      accountScroll('account-scroll');
    }
  }
  getWishlist(myContext.user.email);
  useEffect(() => {
    if (myContext.user.email) {
      getWishlist(myContext.user.email);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.innerWidth <= 576) {
        accountScroll('account-scroll');
      }
    }, 100); // You might increase this to 300ms if DOM isn't fully ready

    return () => clearTimeout(timer); // cleanup in case the component unmounts quickly
  }, []);

  return (
    <div className='profile' >
      <div className='row'>
        <div className='col-sm-4 col-xs-12'>
          <div style={{ display: 'flex' }} className='hello'>
            <img src={profileLogo} alt="" />
            {/* <p className='hello-text'>Hello!</p> */}
            <p className='name-text'>{myContext.user.firstName + " " + myContext.user.lastName}</p>
          </div>
          <div className='profile-list'>
            <p className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/orders'); handleScroll() }}><i className="fa-solid fa-bag-shopping"></i> <span className='head'>Orders</span> <hr /></p>
            <ul className='account-settings'>
              <li className='list-item'><i className="fa-solid fa-user"></i><span className='head'> Account Settings</span></li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/personal-info'); handleScroll() }}>Personal Information</li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/addresses'); handleScroll() }}>Manage Addresses</li>
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>PAN Card Information<hr /></li> */}

            </ul>
            <ul>
              <li className='list-item'><i className="fa-solid fa-briefcase"></i> <span className='head'>My Stuff</span></li>
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Copouns</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Reviews & Ratings</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>All Notifications</li> */}
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/wishlist'); handleScroll() }}>My Whitlist<hr /></li>

            </ul>
            <div id='account-scroll'>
              <p className='list-item' style={{ cursor: "pointer" }} onClick={handelLogout}><i className="fa-solid fa-right-from-bracket"></i> Logout</p>
            </div>
          </div>
        </div>
        <div className='col-sm-8 col-xs-12'>
          
          <div className='wishlist'>
            <div className='wishlist-head'>Wishlist</div>
            {wishlist.length === 0 ?
              <>
                <hr />
                <h3>Empty Wishlist</h3>
              </>
              :
              wishlist.map((item, index) => (
                <>
                  <hr />
                  <div className='product row' style={{background:'transparent'}}>
                    <div className='col-xs-3 col-md-2'>
                      <img className='image' src={`${adminUrl}/uploads/products/${item.images[0].preview}`} alt="" />
                    </div>
                    <div className='col-xs-8 col-md-9'>
                      <div className='details'>
                        <p className='name'>{item.title}
                        </p>
                        <p className='pricing'>
                          <span className='offer-price'>&#8377; {item.pricing.offerPrice}</span>
                          <del className='old-price'> M.R.P &#8377; {item.pricing.MRP}</del>
                        </p>
                      </div>
                    </div>
                    <div className='col-xs-1 col-md-1'>
                      <button className='btn pull-right'
                        style={{ cursor: 'pointer' }}
                        onClick={() => { deleteHandler(index) }}
                      >
                        <i className="fa-solid fa-trash" ></i>
                      </button>
                      <br />
                      <button className='btn  pull-right'
                        onClick={() => { deleteHandler(index) }}
                        style={{marginTop:'2rem'}}
                      >
                        <i className="fa-solid fa-bag-shopping"></i>
                      </button>
                    </div>

                  </div>
                </>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}
